// extracted by mini-css-extract-plugin
export var pillWrapper = "_xu-0";
export var showOverflow = "_xu-1";